var render = function render() {
  var _vm$interfaceDetail$i;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "interface-details"
  }, [_c("section", {
    staticClass: "details"
  }, [_c("div", {
    staticClass: "details-con"
  }, [_c("h2", {
    staticClass: "details-title",
    attrs: {
      title: _vm.interfaceDetail.interface_name
    }
  }, [_vm._v(_vm._s((_vm$interfaceDetail$i = _vm.interfaceDetail.interface_name) === null || _vm$interfaceDetail$i === void 0 ? void 0 : _vm$interfaceDetail$i.slice(0, 15)))]), _c("button", {
    staticClass: "save",
    on: {
      click: _vm.addOrderList
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/save.png"),
      alt: "加入意向单"
    }
  }), _vm._v(" 加入意向单 ")]), _c("p", {
    staticClass: "details-desc"
  }, [_vm._v(_vm._s(_vm.interfaceDetail.short_description))]), _c("div", {
    staticClass: "details-request"
  }, [_c("ul", [_c("li", [_c("span", {
    staticClass: "label"
  }, [_vm._v("请求方式：")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.interfaceDetail.interface_request_method))])]), _c("li", [_c("span", {
    staticClass: "label"
  }, [_vm._v("编码格式：")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.interfaceDetail.interface_encoding_type))])]), _c("li", [_c("span", {
    staticClass: "label"
  }, [_vm._v("返回格式：")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.interfaceDetail.interface_return_format))])])])]), _c("div", {
    staticClass: "details-form"
  }, [_vm._m(0), _c("a-form", {
    staticClass: "form",
    attrs: {
      form: _vm.form
    }
  }, [_vm._l(_vm.debugParamsArr, function (item) {
    return _c("a-form-item", {
      key: item.param_key
    }, [_c("div", {
      staticClass: "form-label",
      attrs: {
        slot: "label"
      },
      slot: "label"
    }, [_c("div", {
      staticClass: "form-label-name"
    }, [_c("span", [_vm._v(_vm._s(item.param_key))]), _c("a-popover", {
      staticClass: "form-label-icon",
      attrs: {
        placement: "right"
      }
    }, [_c("template", {
      slot: "content"
    }, [_c("section", {
      staticClass: "popover-content"
    }, [_c("div", {
      staticClass: "type"
    }, [_c("p", [_vm._v("参数类型"), item.param_not_null === "是" ? _c("span", {
      staticClass: "type-tag"
    }, [_vm._v("必填")]) : _vm._e()]), _c("span", [_vm._v(_vm._s(item.param_type))])]), _c("div", {
      staticClass: "desc"
    }, [_c("p", [_vm._v("描述")]), _c("p", {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.param_description))])]), item.param_range ? _c("div", {
      staticClass: "example"
    }, [_c("p", [_vm._v("示例值"), _c("span", {
      staticClass: "example-link",
      on: {
        click: function ($event) {
          return _vm.toInput(item);
        }
      }
    }, [_vm._v("填入")])]), _c("p", {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.param_range))])]) : _vm._e()])]), _c("img", {
      attrs: {
        src: require("@/assets/images/service/openAI/circle.png"),
        alt: ""
      }
    })], 2)], 1)]), _c("a-input", {
      directives: [{
        name: "decorator",
        rawName: "v-decorator",
        value: _vm.getTooltip(item),
        expression: "getTooltip(item)"
      }]
    })], 1);
  }), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      block: ""
    },
    on: {
      click: _vm.sendRequestEvent
    }
  }, [_vm._v(" 发送请求 ")])], 1)], 2)], 1)])]), _c("section", {
    staticClass: "content"
  }, [_c("a-tabs", {
    model: {
      value: _vm.activeKey,
      callback: function ($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, [_c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: "接口介绍"
    }
  }, [_c("v-desc", {
    attrs: {
      titleList: _vm.leftTitleList,
      interfaceDetail: _vm.interfaceDetail
    },
    on: {
      scrollTitle: _vm.scrollTitle
    }
  })], 1), _c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: "接口调试"
    }
  }, [_c("v-debug", {
    attrs: {
      debugResponseJSON: _vm.debugResponseJSON,
      debugLoading: _vm.debugLoading
    }
  })], 1), _c("a-tab-pane", {
    key: "3",
    attrs: {
      tab: "案例展示"
    }
  }, [_c("v-show", {
    attrs: {
      interfaceDetail: _vm.interfaceDetail
    }
  })], 1)], 1)], 1), _vm.activeKey == "1" ? _c("section", {
    staticClass: "nav-list"
  }, [_c("ul", _vm._l(_vm.leftTitleList, function (item) {
    return _c("li", {
      key: item.key,
      class: item.key === _vm.activeTitle ? "active" : "",
      on: {
        click: function ($event) {
          return _vm.changeTitle(item);
        }
      }
    }, [_vm._v(_vm._s(item.title))]);
  }), 0)]) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("h3", {
    staticClass: "details-form-tile"
  }, [_c("span", {
    staticClass: "line"
  }), _vm._v(" 请求参数")]);
}];
render._withStripped = true;
export { render, staticRenderFns };